module.exports = __webpack_public_path__ + "static/img/11.40d365b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/common/images/t-carousel/11.jpg
// module id = uZ0T
// module chunks = 1